import { AttentionData } from "@/api/studio/insights/types/attention.type";
import { AttentionSubMetrics } from "@/api/studio/insights/types/metrics.type";
import { Progress } from "@/components/ui/progress";
import { classColors } from "@/utils/classification-mapping";
import { getMetricColorValue } from "../../utils/get-metric-color-value";

/* Types */
// remove "pa" as it's handled separately in the alignment component
type RegionMetrics = Exclude<AttentionSubMetrics, "pa">;

/* Prop Types */
interface DigestibilityRegionTableProps {
  regions: AttentionData["regions"];
  metric: RegionMetrics;
}

/*
 * DigestibilityRegionTable component
 *
 * Displays a table of regions for soa, pop or pow metrics.
 */
export const DigestibilityRegionTable = ({ regions, metric }: DigestibilityRegionTableProps) => {

  /* Render */
  return (
    <div className="flex flex-col h-full mt-4">
      <div className="grid grid-cols-[4fr_1fr_3fr] rounded-t-lg bg-base-200 px-4 py-3 items-center">
        <p className="text-sm opacity-60 font-bold">Element</p>
        <p className="text-sm opacity-60 font-bold">Gaze</p>
        <p className="text-sm opacity-60 font-bold text-right">{metric.toUpperCase()}</p>
      </div>
      <div className="flex flex-col">
        {regions.map((region, i) => {
          const actualValue = region[metric] ?? 0;
          const colorValue = getMetricColorValue(actualValue, metric);

          return (
            <div key={i} className="grid grid-cols-[16px_3.5fr_1fr_3fr] gap-4 items-center py-3 justify-between border-b px-4 border-base-300">
              <div className="size-4 rounded-xs" style={{ backgroundColor: classColors[region.classification] }} />
              <div className="flex items-center truncate">
                <span className="text-sm font-semibold truncate">{region.label}</span>
              </div>
              <div className="text-center">
                <span className="text-sm font-semibold">{region.rank}</span>
              </div>
              <div className={`flex items-center gap-4 ${metric === "pow" ? "justify-end" : "justify-between"}`}>
                {metric !== "pow" && <Progress value={colorValue} className="ml-4" />}
                <span className="text-sm font-semibold">{metric === "pow" ? actualValue + "x" : actualValue + "%"}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
